export const defaultSection = [
    {
        title: '供货方式',
        fieldsMatch: [
            {   // 供货方式
                reg: /^supplyType$/,
            },
        ]
    },
    {
        title: '主图视频',
        fieldsMatch: [
            {   // 引用套图
                reg: /^useGroupImages$/,
            },
            {   // 商品主图 
                reg: /^primaryPicture$/,
            },
            {   // 商品视频
                reg: /^primaryVideo$/,
            },
        ]
    },
    {
        title: '基础信息',
        fieldsMatch: [
            { // 商品标题
                reg: /^title$/
            },
            { // 产品属性 (类目属性)
                reg: /^catProp$/,
            },
        ]
    },
    {
        title: '销售信息',
        fieldsMatch: [
            { // 网上订购
                reg: /^onlineTrade$/
            },
            { // 计量单位
                reg: /^cbuUnit$/,
                props: {
                    style: {
                        width: '188px'
                    }
                }
            },
            { // 报价方式
                reg: /^quotationType$/,
            },
            { // 区间报价
                reg: /^priceRange$/,
            },
            { // 产品规格
                reg: /^saleProp$/
            },
            { // 工业类目的产品规格
                reg: /^salePropTable$/
            },
            
            { // 库存扣减设置
                reg: /^invReduce$/,
                
            },
            { // 可售总量
                reg: /^totalSales$/,
                props: {
                    style: {
                        width: '188px'
                    }
                }
            },
            
            { // 最小起订量
                reg: /^beginAmount$/,
                props: {
                    style: {
                        width: '188px'
                    }
                }
            },
            { // 混批
                reg: /^mixBatch$/,
            },
            { // 上架时间
                reg: /^upshelfTime$/,
            }
        ]
    },
    {
        title: '详情信息',
        fieldsMatch: [

            { // 详情描述
                reg: /^description$/
            },
            {   // 详情视频
                reg: /^detailVideo$/,
            },
            //     { // 自定义分类
            //         reg: /^userCategory$/
            //     },
        ]
    },
    {
        title: '服务与承诺',
        fieldsMatch: [
            {  // 私密商品
                reg: /^privacy$/
            },
            {  // 买家保障
                reg: /^buyerProtection$/
            },
            {  // 安心购·定制版
                reg: /^anXinGouService$/
            },
            { // 发货时间
                reg: /^deliveryTime$/
            },
            { // 无理由退货
                reg: /^seven_day$/
            },
        ]
    },
    {
        title: '物流信息',
        fieldsMatch: [
            // { // 发货地址
            //     reg: /^cbuSendAddress$/,
            //     props: {
            //         style: {
            //             width: '100%'
            //         }
            //     }
            // },
            // { // 运费
            //     reg: /^freight$/
            // },
            { // 物流件重尺
                reg: /^showLogisticsCategory$/
            },
            { // 
                reg: /^logisticsWeightTable$/
            },
            // { // 跨境包裹重量
            //     reg: /^suttleWeight$/
            // },
            // { // 商品体积
            //     reg: /^volume$/
            // }
        ]
    },

    // {
    //     title: '上架设置',
    //     fieldsMatch: [
    //         {
    //             reg: /^startTime$/
    //         },
    //     ]
    // }
]